import { Html } from "@react-three/drei";

const Perform = (props) => {
  return (
    <>
      <Html className="page" {...props} fullscreen zIndexRange={[0, 0]}>
        {props.visible ? (
          <div style={{ marginBottom: "12vh", marginTop: "auto" }}>
            <h1 className="title">PERFORMANCE AND EFFICIENCY</h1>
            <p className="text">
              Now entering a new class of strength, speed and versatility—only
              possible with an all-electric design. The powerful drivetrain and
              low center of gravity provides extraordinary traction control and
              torque—enabling acceleration from 0-60 mph in as little as 2.9
              seconds and up to 500 miles of range.
            </p>
          </div>
        ) : null}
      </Html>
    </>
  );
};

export default Perform;
